import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'

export const Route = createFileRoute('/_app/products')({
  staticData: { crumb: 'products' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'products.read'),
  component: Outlet,
})
